<script lang="ts">
  import TaggingGroup from '$lib/components/common/tagging/TaggingGroup.svelte';
  import TagIcon from '$lib/icons/TagIcon.svelte';
  import type { WithCreatorData } from 'garden-common';
  import type { FPost } from 'garden-common';

  export let post: Partial<FPost<string>> & Partial<WithCreatorData>;
</script>

{#if post.tags.length}
  <TaggingGroup taggings={post.tags} groupType="talents" />
{:else}
  <div class="grid place-items-center">
    <div
      class="flex flex-col max-w-screen-sm text-center text-blueish-grey-700 p-4 items-center justify-center"
    >
      <span class="p-4 text-blueish-grey-700 bg-blueish-grey-100 rounded-full font-normal">
        <TagIcon size={54} fill="currentColor" />
      </span>
      <h3 class="font-switzer text-2xl">Tags not updated</h3>
      <span class="font-normal text-blueish-grey-500">
        @{post.creatorData.name} has not tagged anyone <br />on this performance yet, please check
        back later.
      </span>
    </div>
  </div>
{/if}
